import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography, useTheme } from "@mui/material";
import { Component } from "react";
import ErrorIcon from "@mui/icons-material/Error";
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }
        return this.props.children;
    }
}
var ErrorTexts;
(function (ErrorTexts) {
    ErrorTexts["ERROR"] = "Sorry, an error has occurred.";
    ErrorTexts["REFRESH"] = "Please refresh the page. If the issue persists, contact the administrator for assistance.";
})(ErrorTexts || (ErrorTexts = {}));
export const ErrorBoundaryComponent = () => {
    const theme = useTheme();
    return (_jsxs(Stack, Object.assign({ direction: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", gap: "8px", bgcolor: theme.palette.grey[200] }, { children: [_jsx(ErrorIcon, { color: "error", sx: { fontSize: 150 } }), _jsx(Typography, Object.assign({ variant: "h5", component: "h1" }, { children: ErrorTexts.ERROR })), _jsx(Typography, Object.assign({ variant: "h6", component: "h2" }, { children: ErrorTexts.REFRESH }))] })));
};
